var _rect, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Button_Icon-Orange",
    "data-name": "Button Icon-Orange",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4972",
    "data-name": "Rectangle 4972",
    width: 24,
    height: 24,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_971",
    "data-name": "Ellipse 971",
    cx: 6.718,
    cy: 6.718,
    r: 6.718,
    transform: "translate(5.564 5.281)",
    fill: "#ed8b00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chevron",
    d: "M3.5,3.044a.412.412,0,0,0-.033-.165.468.468,0,0,0-.1-.144L.687.117A.384.384,0,0,0,.405,0,.4.4,0,0,0,.2.053.41.41,0,0,0,.055.2.381.381,0,0,0,0,.4.4.4,0,0,0,.127.691L2.539,3.044.127,5.4A.4.4,0,0,0,0,5.686a.379.379,0,0,0,.055.2A.415.415,0,0,0,.2,6.031a.4.4,0,0,0,.2.053.39.39,0,0,0,.282-.113L3.363,3.353a.468.468,0,0,0,.1-.144A.412.412,0,0,0,3.5,3.044Z",
    transform: "translate(10.9 8.958)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronOrange);
export default __webpack_public_path__ + "static/media/icon_chevron_orange.2c77153c23180eabff70a988afcc8a79.svg";
export { ForwardRef as ReactComponent };